import { render, staticRenderFns } from "./ShopSettingsWrapper.vue?vue&type=template&id=1723dcd4&lang=pug&"
import script from "./ShopSettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./ShopSettingsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports